import type {UserPropertyADto} from '@cohort/admin-schemas/userProperty';
import type {GetContactAttributesOutput} from '@cohort/shared/apps/brevo/actions/getContactAttributes';
import type {BrevoUserExportConfig, BrevoUserSyncConfig} from '@cohort/shared/apps/brevo/sync';
import type {UserPropertyDataType} from '@cohort/shared/schema/common/userProperty';

export const BREVO_USER_PROPERTY_PREFIX = 'Brevo';

export type BrevoContactAttribute = GetContactAttributesOutput['attributes'][0];
export type MappedUserProperty = {
  userProperty: UserPropertyADto | null;
  brevoAttribute: BrevoContactAttribute | null;
};

export const buildDefaultUserPropertyColumn = (): BrevoUserSyncConfig['userPropertyColumns'][0] => {
  return {referenceId: '', columnName: '', propertyName: '', dataType: 'string'};
};

export const buildDefaultMappedUserProperty = (): BrevoUserExportConfig['userProperties'][0] => {
  return {userPropertyId: '', brevoAttributeFieldName: ''};
};

export const getDataTypeFromBrevoAttributeType = (attributeType: string): UserPropertyDataType => {
  switch (attributeType) {
    case 'boolean':
      return 'boolean';

    case 'float':
    case 'id':
      return 'number';

    case 'date':
      return 'date';

    default:
      return 'string';
  }
};
